import { FC, useEffect, useState } from "react";
import "./data-filters-row.scss";
import { MeterGroup } from 'primereact/metergroup';
import { Dropdown } from "primereact/dropdown";
import SelectedShopLogo from "assets/side-bar/selected-shop.svg"
import AmountLogo from "assets/side-bar/amount.svg"
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import { useDispatch, useSelector } from "react-redux";
import { getCumulativeICProducts, getCumulativeOPProducts, getICProductConsumption, getICProductsByShop, getOPProductConsumption, setCumulativeICProducts, setCumulativeOPProducts, setICProductConsumption, setOPProductConsumption } from "../../productSlices";

const productsOptions = [
    { name: 'Ice cream', value: 'Ice cream' },
    { name: 'Other products', value: 'Other products' }
];
const selectedShopTemplate = (option) => {
    const name = option?.name || 'Select a shop';
    return (
        <div className="shop-selected">
            <img alt={name} src={SelectedShopLogo} />
            <div className="shop__details__name">{name}</div>
        </div>
    );
};

const selectedProductTemplate = (option) => {
    const name = option?.name || 'Select a product';
    return (
        <div className="shop-selected">
            <div className="shop__details__name">{name}</div>
        </div>
    );
}
const optionTemplate = (option) => {
    return (
        <div className="shop">
            <div>{option.name}</div>
        </div>
    );
};
export enum DataFiltersRowType {
    CONSUMPTION_PER_PRODUCT = 'consumption_per_product',
    CONSUMPTION_FORECAST = 'consumption_forecast',
    STOCK_VIEW = 'stock_view'
}
interface DataFiltersRowProps {
    dateSelector: 'single' | 'range';
    setExternalProductType?:Function;
    productType?:string;
    type: DataFiltersRowType;
    setExternalDates?:Function;
    setExternalProduct?:Function;
}
const DataFiltersRow: FC<DataFiltersRowProps> = ({dateSelector, setExternalProductType, productType, type, setExternalDates, setExternalProduct}) => {
    const [dates, setDates] = useState(null);
    const [selectedShop, setSelectedShop] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState('');
    const currentPath = window.location.pathname;
    const user = useSelector((state: any) => state.auth.user);
    const userShops = user.shops;
    const shopsOptions = userShops.map((shop: any) => ({ name: shop.name, value: shop.id }));
    const dispatch: Function = useDispatch();
    
    useEffect(() => {
        const savedShop = localStorage.getItem(`selectedShop${currentPath}`);
        const savedProduct = localStorage.getItem(`selectedProduct${currentPath}`);
        const savedDates = localStorage.getItem(`dates${currentPath}`);
        if (savedShop) setSelectedShop(savedShop.split(','));
        if (savedProduct) setSelectedProduct(savedProduct);
        if (savedDates) {
            const parsedDates = JSON.parse(savedDates);
            if (dateSelector === 'single') {
                setDates(new Date(parsedDates));
            } else {
                // For range selector, convert both dates in the array
                setDates(parsedDates.map((date: string) => new Date(date)));
            }
        }
    }, [currentPath, dateSelector]);

    useEffect(() => {
        localStorage.setItem(`selectedShop${currentPath}`, selectedShop.join(','));
        localStorage.setItem(`selectedProduct${currentPath}`, selectedProduct);
        if (dates) {
            localStorage.setItem(`dates${currentPath}`, JSON.stringify(dates));
        }
    }, [selectedShop, selectedProduct, dates, currentPath]);

    useEffect(()=>{
        if(selectedShop && selectedProduct){
            setExternalProductType && setExternalProductType(selectedProduct)
            setExternalDates && setExternalDates(dates)
            setExternalProduct && setExternalProduct(selectedProduct)
            if(selectedProduct === 'Ice cream'){
                if(type === DataFiltersRowType.CONSUMPTION_PER_PRODUCT){    
                    if(dates && dates[0] && dates[1]) {
                        dispatch(getICProductConsumption(selectedShop, dates[0].toDateString(), dates[1].toDateString()))
                    }                    
                }
                else if(type === DataFiltersRowType.STOCK_VIEW){
                    if(dates) {
                        // Ensure dates is treated as a Date object
                        const dateObj = dates instanceof Date ? dates : new Date(dates);
                        dispatch(getCumulativeICProducts(selectedShop, dateObj.toDateString()))
                    }                  
                }
            }
            else if(selectedProduct === 'Other products'){
                if(type === DataFiltersRowType.CONSUMPTION_PER_PRODUCT){    
                    if(dates && dates[0] && dates[1]) {
                        dispatch(getOPProductConsumption(selectedShop, dates[0].toDateString(), dates[1].toDateString()))
                    }                    
                }
                else if(type === DataFiltersRowType.STOCK_VIEW){
                    if(dates) {
                        // Ensure dates is treated as a Date object
                        const dateObj = dates instanceof Date ? dates : new Date(dates);
                        dispatch(getCumulativeOPProducts(selectedShop, dateObj.toDateString()))
                    }                   
                }
            }
        }
    },[selectedShop, dates, selectedProduct])
    return (
        <div className="data-filters-row">
            <Calendar locale="eu" pt={{root: {firstDayOfWeek: 1}}} dateFormat="dd/mm/yy" value={dates} onChange={(e) => setDates(e.value)} selectionMode={dateSelector} readOnlyInput hideOnRangeSelection  placeholder="Select date"/>
            <MultiSelect value={selectedShop} onChange={(e) => setSelectedShop(e.value)} options={shopsOptions} optionLabel="name" placeholder="Select a shop" 
                display="chip" itemTemplate={optionTemplate} filterTemplate={selectedProductTemplate} className="shop-dropdown"
                />
            <Dropdown value={selectedProduct} onChange={(e) => setSelectedProduct(e.value)} options={productsOptions} optionLabel="name" placeholder="Select a product" 
                valueTemplate={selectedProductTemplate} itemTemplate={optionTemplate} className="shop-dropdown"
                />
        </div>
    );
};

export default DataFiltersRow;
